import { useMutation } from '@tanstack/react-query';
import { api } from '~/api/utils/api-base';
import { Tagging } from '~/shared/types/tagging';

export type CreateTaggingParams = {
  tagging: {
    tag_id: number | undefined;
    entity_type: string;
    entity_id: number;
  },
  tag?: {
    name: string;
    tag_category_id: number;
  }
}

export const useCreateTagging = () => {
  return useMutation({
    mutationFn: async ({ tagging, tag }: CreateTaggingParams) => {
      const response = await api.post<Tagging>('/taggings', { tagging, tag });
      return response.data;
    },
  });
};

export const useDestroyTagging = () => {
  return useMutation({
    mutationFn: async (id: number) => {
      const response = await api.delete(`/taggings/${id}`);
      return response.data;
    },
  });
};

export const useUpdateTagging = () => {
  return useMutation({
    mutationFn: async ({ id, deactivated }: { id: number; deactivated: boolean }) => {
      const response = await api.patch<Tagging>(`/taggings/${id}`, { deactivated });
      return response.data;
    },
  });
};

// only used for toggling the deactivated state of a tagging for now and likely forever
export const useUpdateLeadTopic = () => {
  return useMutation({
    mutationFn: async ({
      leadSlug,
      taggingId,
      deactivated
    }: {
      leadSlug: string;
      taggingId: number;
      deactivated: boolean
    }) => {
      const response = await api.patch<Tagging>(`/leads/${leadSlug}/topics/${taggingId}`, { deactivated });
      return response.data;
    },
  });
};